import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryTransferDetailTableModel } from 'src/app/models/tables/inventory/inventory-transfer-detail-table.model';
import { InventoryTransferTableModel } from 'src/app/models/tables/inventory/inventory-transfer-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryTransferDetailService } from 'src/app/services/inventory/inventory-transfer-detail.service';
import { InventoryTransferService } from 'src/app/services/inventory/inventory-transfer.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-inventory-transfer',
  templateUrl: './inventory-transfer.component.html',
  styleUrls: ['./inventory-transfer.component.scss'],
  standalone: false
})
export class InventoryTransferComponent implements OnInit {

  generalHeader: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<InventoryTransferTableModel> = new PagedResponseModel<InventoryTransferTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  detailData: PagedResponseModel<InventoryTransferDetailTableModel> = new PagedResponseModel<InventoryTransferDetailTableModel>();
  nameWindow: string = 'Traslados';
  projectName = ProjectName.projectName;

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  limit: number = 10;
  page: number = 1;
  permissionUpdatable: boolean = false;
  previousSort: { field: string; isAscsendant: number };
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = "";

  constructor(private headerService: HeaderService,
    private inventoryTransferService: InventoryTransferService,
    private inventoryTransferDetailService: InventoryTransferDetailService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.getPermission();
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem('inventory-transfer');
    filters ? this.filters = JSON.parse(filters) : [];
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getInventoryTransfersForGeneralConsultation()
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async exportFileXlsx(fileName: string, blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  async exportDetailConsultation() {
    try {
      const blob = await firstValueFrom(this.inventoryTransferDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant));
      if (!blob) return;

      this.exportFileXlsx('DetallesTraslados', blob);
    } catch (error) {
      console.error('Error al exportar los traslados detalle.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const blob = await firstValueFrom(this.inventoryTransferService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      if (!blob) return;

      this.exportFileXlsx('Traslados', blob)
    } catch (error) {
      console.error('Error al exportar los traslados.', error);
    }
  }

  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.inventoryTransferDetailService.getColumnsForDetailConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta detalle.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.inventoryTransferService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }
  async getInventoryTransfersForGeneralConsultation() {
    try {
      this.generalData = await firstValueFrom(this.inventoryTransferService.getInventoryTransfersForGeneralConsultation(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar las entradas de inventario.', error);
    }
  }

  async getInventoryTransferDetailsForDetailConsultation() {
    try {
      this.detailData = await firstValueFrom(this.inventoryTransferDetailService.getInventoryTransferDetailsForDetailConsultation(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los detalles de las entradas de inventario.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error to get permission profile by URL.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getInventoryTransfersForGeneralConsultation()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getInventoryTransferDetailsForDetailConsultation()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  newInventoryEntry() {
    this.router.navigate(['/inventory-transfer/register']);
  }

  onAction(event: { action: string, item?: InventoryTransferTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/inventory-transfer/register/${event.item.inventoryTransferId}`]);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getInventoryTransfersForGeneralConsultation();
        break;
      case 1:
        await this.getInventoryTransferDetailsForDetailConsultation();
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);

    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  private removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  private processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }
}
